import { render, staticRenderFns } from "./DispatchStatistics.vue?vue&type=template&id=53f8973a&scoped=true"
import script from "./DispatchStatistics.vue?vue&type=script&lang=js"
export * from "./DispatchStatistics.vue?vue&type=script&lang=js"
import style0 from "./DispatchStatistics.vue?vue&type=style&index=0&id=53f8973a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f8973a",
  null
  
)

export default component.exports